var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.288 10.1149C15.726 9.17625 14.8716 8.4479 13.8559 8.04152C12.8402 7.63514 11.7192 7.57318 10.6649 7.86514C9.61058 8.1571 8.68114 8.78686 8.01914 9.65782C7.35713 10.5288 6.99912 11.5929 7 12.6869C6.99912 13.7809 7.35713 14.8449 8.01914 15.7159C8.68114 16.5869 9.61058 17.2166 10.6649 17.5086C11.7192 17.8006 12.8402 17.7386 13.8559 17.3322C14.8716 16.9258 15.726 16.1975 16.288 15.2589L14.573 14.2309C14.3031 14.6805 13.9201 15.0515 13.4621 15.3069C13.0041 15.5624 12.4871 15.6933 11.9627 15.6866C11.4384 15.68 10.9249 15.536 10.4735 15.269C10.0222 15.002 9.64868 14.6214 9.39029 14.1651C9.13189 13.7087 8.99763 13.1926 9.00089 12.6682C9.00414 12.1438 9.1448 11.6295 9.40885 11.1764C9.67289 10.7233 10.0511 10.3473 10.5057 10.086C10.9604 9.82462 11.4756 9.68701 12 9.68687C13.093 9.68687 14.05 10.2709 14.573 11.1439L16.288 10.1149ZM22 12.6869C22 7.16687 17.52 2.68687 12 2.68687C6.48 2.68687 2 7.16687 2 12.6869C2 18.2069 6.48 22.6869 12 22.6869C17.52 22.6869 22 18.2069 22 12.6869ZM4 12.6869C4 8.26687 7.58 4.68687 12 4.68687C16.42 4.68687 20 8.26687 20 12.6869C20 17.1069 16.42 20.6869 12 20.6869C7.58 20.6869 4 17.1069 4 12.6869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/Copyright.14b21a74e991bca28cb79b61998ded0d.svg";
export { ForwardRef as ReactComponent };